<template>
  <div v-if="yukleniyor" class="text-center text-sm text-gray-500 dark:text-gray-400 py-8">
    Yükleniyor…
  </div>
  <div v-else-if="bosDurum" class="text-center text-sm text-gray-500 dark:text-gray-400 py-8">
    Bu sayfa için henüz yardım metni yok.
  </div>
  <div v-else class="prose max-w-full overflow-auto text-gray-800 dark:text-gray-100" v-html="Icerik" />
</template>

<script>
import { sanitizeYardimIcerik } from "@/utils/yardimIcerikSanitize";

// YardimPaneli.vue (Drawer) ve GenelYardimSayfasi.vue (route) aynı GetYardimInfo_URL akışını
// paylaşır — SB §3.6 "Metin gövdesi panelle aynı bileşenden gelir, kopya yazılmaz" (YR §4.4).
// `aktif` false iken (ör. panel kapalı) çözülmüş anahtar değişse bile istek atılmaz.
export default {
  name: "YardimGovde",
  props: {
    anahtar: { type: String, default: null },
    aktif: { type: Boolean, default: true },
  },
  emits: ["yuklendi"],
  data() {
    return {
      Baslik: "",
      Icerik: "",
      WebSayfaAd: "",
      Tarih: "",
      bosDurum: false,
      yukleniyor: false,
      sonAnahtar: null,
    };
  },
  watch: {
    aktif(v) { if (v) this.yardimiGetir(); },
    anahtar() { if (this.aktif) this.yardimiGetir(); },
  },
  mounted() {
    if (this.aktif) this.yardimiGetir();
  },
  methods: {
    yardimiGetir() {
      if (!this.anahtar) {
        this.bosDurum = true;
        this.Baslik = ""; this.Icerik = ""; this.WebSayfaAd = ""; this.Tarih = "";
        this.$emit("yuklendi", { Baslik: "", WebSayfaAd: "", Tarih: "", bosDurum: true });
        return;
      }
      if (this.anahtar === this.sonAnahtar) return;
      this.yukleniyor = true;
      this.bosDurum = false;
      this.$Servis("POST", "GetYardimInfo_URL", { Url: this.anahtar }).then((res) => {
        this.yukleniyor = false;
        this.sonAnahtar = this.anahtar;
        if (res.status === 200 && res.data && res.data.length > 0) {
          this.Baslik = res.data[0].Baslik;
          this.Icerik = sanitizeYardimIcerik(res.data[0].Icerik);
          this.WebSayfaAd = res.data[0].WebSayfaAd;
          this.Tarih = res.data[0].Tarih;
          this.bosDurum = false;
        } else {
          this.bosDurum = true;
          this.Baslik = ""; this.Icerik = ""; this.WebSayfaAd = ""; this.Tarih = "";
        }
        this.$emit("yuklendi", { Baslik: this.Baslik, WebSayfaAd: this.WebSayfaAd, Tarih: this.Tarih, bosDurum: this.bosDurum });
      });
    },
  },
};
</script>
